import { initSlider } from "./sliders/slider";
import { initTabSlider } from "./sliders/tab-slider";
import { inithomeSlider } from "./sliders/home-slider";
import { isMobile } from "./Helper.js";
import {
    menu,
    menuClose,
    checkCurrentPage,
    footerMenu,
    menuAccordian,
    btnSpan,
    hamburg,
    initMobProjectToggle,
} from "./menu/menu";
import { createLazyLoad, destroyLazyLoad } from "./animations/lazyLoad";
import { siteSearch } from "./site-search/site-search";
import { accordianView } from "./components/accordian";

import { SocialShareKit } from "./components/social-share-kit.min";

import {
    pillShapeTransform,
    initTextReveal,
    initMapSlider,
} from "./animations/scrollTriggerAni.js";

import { initFooterFocus } from "./footer/footer-focus";

import { scroll } from "../Module/smooth-scrollbar/smoothscrollBar";

import { setupFilterButtons } from "./filters.js";
setupFilterButtons();

import { venoboxInit } from "./siteFun";
import { initCF7CustomSelect } from "./cf7-select";

import { openBtns } from "./c-popup"; 

import { acfMaps } from "./proj-mapApi";
// This makes the function "Public" so Google can find it
window.initAcfMaps = acfMaps;

import { initMap } from "./map";


import { pinSection } from "./home-about";

window.SocialShareKit = SocialShareKit;
menu();

/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
                scrollToSection
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

function scrollToSection() {
    document.querySelectorAll('a[href^="#"]').forEach((link) => {
        link.addEventListener("click", function (e) {
            e.preventDefault();

            const targetId = this.getAttribute("href").substring(1);
            const target = document.getElementById(targetId);
            if (!target) return;

            const offset = 100;
            const targetPosition =
                target.getBoundingClientRect().top + window.pageYOffset - offset;

            window.scrollTo({
                top: targetPosition,
                behavior: "smooth",
            });
        });
    });
}

/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
                Header Scroll Effect
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
// 1. Create a state tracker outside the function
// 1. Define the function so it can be reused

function initHeaderScroll() {
    const header = document.querySelector("header");
    if (!header) return; // Safety check

    const handleScroll = () => {
        if (window.scrollY > 60) {
            header.classList.add("show");
        } else {
            header.classList.remove("show");
        }
    };

    // Run once on load
    handleScroll();

    // Attach the listener
    window.addEventListener("scroll", handleScroll);
}

/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
                Sticky Header
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

function initMenuHover() {
    const lists = document.querySelectorAll(".list");
    const wraps = document.querySelectorAll(".menu-card-wrap");

    lists.forEach((item, index) => {
        item.addEventListener("mouseenter", () => {
            // Reset lists
            lists.forEach((l) => l.classList.remove("is-active"));

            // Hide all wraps smoothly
            wraps.forEach((w) => {
                w.classList.remove("is-active");
                w.classList.add("is-hiding");
            });

            // Activate current list
            item.classList.add("is-active");

            // Show matching wrap
            const activeWrap = wraps[index];
            if (activeWrap) {
                activeWrap.classList.remove("is-hiding");
                activeWrap.classList.add("is-active");
            }
        });
    });
}

/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
                Custom dropdown menu
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

function initProjectsMenuHover(triggerId, dropdownId) {
    const trigger = document.getElementById(triggerId);
    const dropdown = document.getElementById(dropdownId);

    // Debugging: This will show in your browser console (F12) if elements aren't found
    if (!trigger || !dropdown) {
        console.warn(`Menu elements not found: ${triggerId} or ${dropdownId}`);
        return;
    }

    let timeout;

    const showMenu = () => {
        clearTimeout(timeout);
        dropdown.classList.add("is-active"); 
    };

    const hideMenu = () => {
        // Wait 150ms before hiding to give user time to move mouse to the dropdown
        timeout = setTimeout(() => {
            // Only hide if the mouse isn't currently over either element
            if (!trigger.matches(":hover") && !dropdown.matches(":hover")) {
                dropdown.classList.remove("is-active");
            }
        }, 150);
    };

    // Add Listeners to Trigger
    trigger.addEventListener("mouseenter", showMenu);
    trigger.addEventListener("mouseleave", hideMenu);

    // Add Listeners to Dropdown (prevents closing when moving mouse into it)
    dropdown.addEventListener("mouseenter", showMenu);
    dropdown.addEventListener("mouseleave", hideMenu);
}

// Initialize both menus
// initProjectsMenuHover("menu-projects", "d-menu-projects");
// initProjectsMenuHover("menu-locations", "d-menu-locations");

/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
             Amenities Tab
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
/**
 * Initializes the Amenities Gallery interaction
 * Handles active state, mobile scrolling, and image fading
 */

function initAmenitiesGallery() {
    const listItems = document.querySelectorAll(".amenity-item");
    const mainImg = document.getElementById("main-amenity-img");

    if (!listItems || listItems.length === 0 || !mainImg) {
        console.warn("Gallery elements not found");
        return;
    }

    listItems.forEach((item) => {
        // Use an anonymous function to keep 'this' bound to the element
        item.addEventListener("click", function (e) {
            e.preventDefault(); // Prevents jumps if <li> contains <a>

            console.log("Clicked:", this.innerText); // Debugging line

            // 1. Clear ALL active classes first
            listItems.forEach((li) => li.classList.remove("show"));

            // 2. Add to the clicked one
            this.classList.add("show");

            // 3. Handle Scroll (Mobile)
            if (window.innerWidth < 992) {
                this.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "center",
                });
            }

            // 4. Image Transition
            // const newSrc = this.getAttribute("data-image");
            // if (newSrc && mainImg.src !== newSrc) {
            //     mainImg.style.opacity = 0;
            //     setTimeout(() => {
            //         mainImg.src = newSrc;
            //         mainImg.style.opacity = 1;
            //     }, 300);
            // }

            // 4. Image Transition
            const newSrc = this.getAttribute("data-image");
            if (newSrc && mainImg.src !== newSrc) {
                // Phase 1: Fade out and shrink slightly
                mainImg.style.opacity = 0;
                mainImg.style.transform = "scale(0.98)"; 

                setTimeout(() => {
                    mainImg.src = newSrc;
                    
                    // Phase 2: Fade in and return to full size
                    mainImg.onload = () => {
                        mainImg.style.opacity = 1;
                        mainImg.style.transform = "scale(1)";
                    };
                }, 300);
            }



        });
    });
}

/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
             Floorplan Tab
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

/**
 * Initializes the floorplan viewer with smooth transitions using .show class.
 */
function initFloorplanViewer() {
    const viewer = document.querySelector(".floorplan-viewer");

    // Safety exit if element is not on current page
    if (!viewer) return;

    const sidebarBtns = viewer.querySelectorAll(".room-btn");
    const mainCards = viewer.querySelectorAll(".main-card");
    const baseUrl = viewer.getAttribute("data-base-url");

    /**
     * Internal helper to update visibility and image sources
     */
    const updateView = () => {
        const activeRoomBtn = viewer.querySelector(".room-btn.show");
        if (!activeRoomBtn) return;

        const activeRoomId = activeRoomBtn.dataset.room;

        mainCards.forEach((card) => {
            const isCardActive = card.dataset.room === activeRoomId;
            card.classList.toggle("show", isCardActive);

            if (isCardActive) {
                const activeTypeBtn = card.querySelector(".type-btn.show");
                if (!activeTypeBtn) return;

                const activeTypeId = activeTypeBtn.dataset.type;
                const grids = card.querySelectorAll(".plans-grid");

                grids.forEach((grid) => {
                    const isGridActive = grid.dataset.type === activeTypeId;
                    grid.classList.toggle("show", isGridActive);

                    if (isGridActive) {
                        // UPDATE IMAGE SOURCES FROM DATA ATTRIBUTE
                        grid.querySelectorAll("img").forEach((img) => {
                            const dynamicSrc = img.dataset.src; // Grab from data-src

                            if (dynamicSrc && img.src !== dynamicSrc) {
                                img.src = dynamicSrc;
                            }
                        });
                    }
                });
            }
        });
    };

    // Attach Sidebar (Room) Listeners
    sidebarBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
            sidebarBtns.forEach((b) => b.classList.remove("show"));
            btn.classList.add("show");
            updateView();
        });
    });

    // Attach Type Tab Listeners (Event Delegation)
    viewer.addEventListener("click", (e) => {
        if (e.target.classList.contains("type-btn")) {
            const nav = e.target.closest(".tabs-header");
            if (nav) {
                nav
                    .querySelectorAll(".type-btn")
                    .forEach((b) => b.classList.remove("show"));
                e.target.classList.add("show");
                updateView();
            }
        }
    });

    // Initial load
    updateView();
}

/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
             FAQ Tab
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

function switchTab() {
    // Listen to the document to handle all tab containers at once
    document.body.addEventListener("click", (e) => {
        const btn = e.target.closest(".tab-btn");
        const container = e.target.closest('[class*="tab-container"]');

        if (!btn || !container) return;

        const targetPane = document.getElementById(btn.dataset.target);
        const wrapper = container.querySelector(".tab-content-wrapper");

        if (targetPane && wrapper) {
            // Toggle Classes for Buttons
            container
                .querySelectorAll(".tab-btn")
                .forEach((b) => b.classList.toggle("show", b === btn));

            // Toggle Classes for Panes
            wrapper.querySelectorAll(".tab-pane").forEach((p) => {
                const isTarget = p === targetPane;
                p.style.display = isTarget ? "block" : "none";
                // Small delay to trigger CSS transition
                setTimeout(() => p.classList.toggle("show", isTarget), 20);
            });

            // Smooth Scroll alignment
            btn.scrollIntoView({
                behavior: "smooth",
                inline: "center",
                block: "nearest",
            });
        }
    });
}

/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
             Mobile Filter expand
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
const toggleMobileFilter = () => {
    const mobFilter = document.querySelector('.mob-filter .arrow');
    const filterBar = document.querySelector('.mob-filter-bar');

    if (!mobFilter || !filterBar) return;

    // 1. The Toggle: Only triggers when clicking the arrow
    mobFilter.addEventListener('click', (e) => {
        if (window.innerWidth > 767) return;

        e.stopPropagation(); // Prevents the window listener from firing immediately

        const isOpen = filterBar.classList.toggle('active');
        mobFilter.classList.toggle('is-open');
        mobFilter.setAttribute('aria-expanded', isOpen);
    });

    // 2. The Interior: Prevents clicks inside the bar from closing it
    filterBar.addEventListener('click', (e) => {
        if (window.innerWidth <= 767) {
            e.stopPropagation();
        }
    });

    // 3. The Exterior: Closes the bar if clicking anywhere else on the screen
    window.addEventListener('click', () => {
        if (window.innerWidth > 767) return;

        if (filterBar.classList.contains('active')) {
            filterBar.classList.remove('active');
            mobFilter.classList.remove('is-open');
            mobFilter.setAttribute('aria-expanded', 'false');
        }
    });
};

/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
            Generic filter with style
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
function initCustomSelect(selector) {
    const wrappers = document.querySelectorAll(selector);

    wrappers.forEach(wrapper => {
        if (wrapper.classList.contains('js-initialized')) return;

        const nativeSelect = wrapper.querySelector('.custom-select');
        const nativeOptions = nativeSelect.querySelectorAll('option');

        // Create the Display Box
        const styledBox = document.createElement('div');
        styledBox.className = 'select-styled';
        styledBox.innerHTML = `<span>${nativeOptions[0].textContent}</span><span class="chevron"></span>`;
        wrapper.appendChild(styledBox);

        // Create the Options List
        const optionsList = document.createElement('ul');
        optionsList.className = 'select-options';

        // --- FIX: Stop Lenis from hijacking the scroll ---
        optionsList.setAttribute('data-lenis-prevent', 'true');
        optionsList.addEventListener('wheel', (e) => {
            e.stopPropagation();
        }, { passive: false });

        nativeOptions.forEach((opt, index) => {
            if (index === 0) return;
            const li = document.createElement('li');
            li.textContent = opt.textContent;
            li.dataset.value = opt.value;
            // Copy normalized attribute if exists
            if (opt.dataset.normalized) {
                li.dataset.normalized = opt.dataset.normalized;
            }
            li.addEventListener('click', (e) => {
                e.stopPropagation();
                styledBox.querySelector('span').textContent = li.textContent;
                nativeSelect.value = li.dataset.value;
                wrapper.classList.remove('active');
                nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
            });
            optionsList.appendChild(li);
        });

        wrapper.appendChild(optionsList);

        // styledBox.addEventListener('click', (e) => {
        //     e.stopPropagation();
        //     wrapper.classList.toggle('active');
        // });

        // --- THE TWEAK IS HERE ---
        styledBox.addEventListener('click', (e) => {
            e.stopPropagation();

            // 1. Find all other wrappers and close them
            wrappers.forEach(otherWrapper => {
                if (otherWrapper !== wrapper) {
                    otherWrapper.classList.remove('active');
                }
            }); 

            // 2. Toggle the current one
            wrapper.classList.toggle('active');
        });

        wrapper.classList.add('js-initialized');
    });
}


/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
            Custom scroll bar
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
function updateArrowVisibility() {
  const container = document.querySelector('.tab-menu-scroll');
  const arrows = document.querySelectorAll('.scroll-arrow');
  
  if (!container) return;

  // Check if content height is greater than the visible container height
  const isScrollable = container.scrollHeight > container.clientHeight;

  arrows.forEach(arrow => {
    if (isScrollable) {
      arrow.classList.add('visible');
    } else {
      arrow.classList.remove('visible');
    }
  });
}





function init() {   
    

    updateArrowVisibility();
    toggleMobileFilter();
    initMobProjectToggle();
    hamburg();
    btnSpan();
    siteSearch();
    createLazyLoad();
    checkCurrentPage();
    initSlider();
    initTabSlider();
    inithomeSlider();
    menuAccordian();
    accordianView();

    venoboxInit();   
    initCF7CustomSelect();    

    initMap();

    initFooterFocus();
    footerMenu();
    // simpleParalax();
    // cardOverlap();

    initMapSlider();

    // ADD THIS INSTEAD:
    // Create a global bridge so Google can call it when the script arrives
    window.acfMaps = () => {
        console.log("Google Maps API loaded, initializing ACF maps...");
        acfMaps();
    };
    // If Google is already loaded (from a previous page load/cache), run it immediately
    if (typeof google !== 'undefined') {
        acfMaps();
    }

    initTextReveal();
    initHeaderScroll();
    initMenuHover();
    // initProjectsMenuHover();

    initProjectsMenuHover("menu-projects", "d-menu-projects");
    initProjectsMenuHover("menu-locations", "d-menu-locations");

    scrollToSection();
    initAmenitiesGallery();  
    initFloorplanViewer();
    switchTab();
    initCustomSelect('.select-wrapper');

    // In your init() function:
    openBtns('modalOverlay', '#openModal', 'closeModal');

    // initCF7CustomSelect();

    if (!isMobile()) {
        pillShapeTransform();
    }
    setTimeout(() => {
        pinSection();
        SocialShareKit.init();
    }, 100);
}

function initBeforeEnter() {
    menuClose();
}
function destroyBeforeLeave() {
    destroyLazyLoad();
}
export { init, initBeforeEnter, destroyBeforeLeave };
